<template>
  <v-container fluid grid-list-sm>
    <v-card v-if="!clmDocSection">
      <v-toolbar :dense="true"  v-if="!clmDocSection">
        <v-toolbar-title> <v-icon>mdi-file-document</v-icon> Claim Documents </v-toolbar-title>
        <v-spacer></v-spacer>
        <span class="body-2">Claim No: {{ this.commonInfo.clmNo }}</span>
        <v-btn text icon @click="doClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-expand-transition>
        <v-data-table
          :headers="headers"
          :items="items"
          class="elevation-1"
          :loading="loading"
          :server-items-length="totalItems"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          v-bind:options.sync="pagination"
          v-if="!clmDocSection"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.docHdgDesc }}</td>
              <td>{{ row.item.clmtNo }} / {{ row.item.clmItem }}</td>
              <td>{{ row.item.inter }}</td>
              <td>{{ row.item.tranType1 }}</td>
              <td>{{ row.item.docNo }}</td>
              <td>{{ formatDisplayDate(row.item.genDate) }}</td>
              <td>{{ formatDisplayDate(row.item.sentDate) }}</td>
              <td>{{ formatDisplayDate(row.item.recvDate) }}</td>
              <td class="table-action-header">
                <table-action
                  :rowData="row"
                  query
                  @query="doQuery"
                  :review="canReview(row)"
                  @review="doReview"
                  :remove="canRemove(row)"
                  @remove="doPromptRemove"
                ></table-action>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-expand-transition>
      <confirm v-model="promptRemove" @ok="doDelete">
        <p>Are you sure you want to delete the selected Claim Doc?</p>
        <div class="queryValue">
          Claim Doc: {{ selected.docHdgDesc }}<br />
          Claimant No.: {{ selected.clmtNo }}<br />
          Claim Item: {{ selected.clmItem }}<br />
        </div>
      </confirm>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark @click.native="doReprint"> Reprint<v-icon dark right>mdi-printer</v-icon> </v-btn>
        <!-- <v-btn color="red darken-1" text @click.native="doClose">Close</v-btn> -->
      </v-card-actions>
    </v-card>
    <v-card v-if="clmDocSection">
      <v-toolbar :dense="true" :flat="true" >
        <v-icon v-if="reviewMode">mdi-pencil</v-icon>
        <v-icon v-else-if="queryMode">mdi-magnify</v-icon>
        <v-toolbar-title v-if="reviewMode">Edit Claim Documents Detail</v-toolbar-title>
        <v-toolbar-title v-else-if="queryMode">View Claim Documents Detail</v-toolbar-title>
      </v-toolbar>
      <v-card-text id="clmDocCard" style="height: 620px; overflow-y: scroll">
        <v-layout row wrap>
          <v-flex md6 xs12>
            <v-text-field
              disabled
              v-model="clmDocForm.docHdgDesc"
              :label="labels.docHdg"
              :error-messages="errors.collect('clmDocForm.docHdgDesc')"
              data-vv-name="clmDocForm.docHdgDesc"
              :data-vv-as="labels.docHdg"
            ></v-text-field>
          </v-flex>
          <v-flex> </v-flex>
          <v-flex md4 xs12>
            <v-checkbox color="primary" :label="labels.genDoc" v-model="clmDocForm.genDoc" :disabled="queryMode"></v-checkbox>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md6 xs12>
            <v-text-field
              disabled
              v-model="clmDocForm.clmtNoClmItem"
              :label="labels.clmtNo"
              :error-messages="errors.collect('clmDocForm.clmtNoClmItem')"
              data-vv-name="clmDocForm.clmtNoClmItem"
              :data-vv-as="labels.clmtNo"
            ></v-text-field>
          </v-flex>
          <v-flex> </v-flex>
          <v-flex md4 xs12>
            <v-checkbox color="primary" :label="labels.emailRecip" v-model="clmDocForm.emailRecip" :disabled="queryMode"></v-checkbox>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md6 xs12>
            <v-text-field
              disabled
              v-model="clmDocForm.inter"
              :label="labels.inter"
              :error-messages="errors.collect('clmDocForm.inter')"
              data-vv-name="clmDocForm.inter"
              :data-vv-as="labels.inter"
            ></v-text-field>
          </v-flex>
          <v-flex> </v-flex>
          <v-flex md4 xs12>
            <v-checkbox color="primary" :label="labels.smsRecip" v-model="clmDocForm.smsRecip" :disabled="queryMode"></v-checkbox>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md6 xs12>
            <v-text-field
              disabled
              v-model="clmDocForm.tranType1DocNo"
              :label="labels.tranType1"
              :error-messages="errors.collect('clmDocForm.tranType1DocNo')"
              data-vv-name="clmDocForm.tranType1DocNo"
              :data-vv-as="labels.tranType1"
            ></v-text-field>
          </v-flex>
          <v-flex> </v-flex>
          <v-flex md4 xs12>
            <v-checkbox color="primary" :label="labels.emailAgt" v-model="clmDocForm.emailAgt" :disabled="queryMode"></v-checkbox>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md3 xs12>
            <cal-picker
              disabled
              v-model="clmDocForm.genDate"
              :label="labels.genDate"
              :data-vv-as="labels.genDate"
              data-vv-name="genDate"
              :error-messages="errors.collect('genDate')"
            ></cal-picker>
          </v-flex>
          <v-flex md3 xs12>
            <v-text-field
              disabled
              v-model="clmDocForm.genBy"
              :label="labels.genBy"
              :error-messages="errors.collect('clmDocForm.genBy')"
              data-vv-name="clmDocForm.genBy"
              :data-vv-as="labels.genBy"
            ></v-text-field>
          </v-flex>
          <v-flex> </v-flex>
          <v-flex md4 xs12>
            <v-checkbox color="primary" :label="labels.smsAgt" v-model="clmDocForm.smsAgt" :disabled="queryMode"></v-checkbox>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md3 xs12>
            <cal-picker
              v-model="clmDocForm.sentDate"
              :label="labels.sentDate"
              :data-vv-as="labels.sentDate"
              data-vv-name="sentDate"
              :error-messages="errors.collect('sentDate')"
              :disabled="disabledSentDate"
            ></cal-picker>
          </v-flex>
          <v-flex md3 xs12>
            <v-text-field
              disabled
              v-model="clmDocForm.sentBy"
              :label="labels.sentBy"
              :error-messages="errors.collect('clmDocForm.sentBy')"
              data-vv-name="clmDocForm.sentBy"
              :data-vv-as="labels.sentBy"
            ></v-text-field>
          </v-flex>
          <v-flex> </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md3 xs12>
            <cal-picker
              :disabled="disabledRecvDate"
              v-model="clmDocForm.recvDate"
              :label="labels.recvDate"
              :data-vv-as="labels.recvDate"
              data-vv-name="recvDate"
              :error-messages="errors.collect('recvDate')"
            ></cal-picker>
          </v-flex>
        </v-layout>
        <v-spacer class="mt-2"></v-spacer>
        <v-layout row wrap>
          <v-flex md6 xs6>
            <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
            <div class="queryValue">{{ clmDocForm.createdBy }}</div>
          </v-flex>
          <v-flex md6 xs6>
            <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
            <div class="queryValue">{{ formatDisplayDate(clmDocForm.createdDate) }}</div>
          </v-flex>
        </v-layout>
        <v-spacer class="mt-1"></v-spacer>
        <v-layout row wrap>
          <v-flex md6 xs6>
            <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
            <div class="queryValue">{{ clmDocForm.modifiedBy }}</div>
          </v-flex>
          <v-flex md6 xs6>
            <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
            <div class="queryValue">{{ formatDisplayDate(clmDocForm.modifiedDate) }}</div>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-if="reviewMode" color="primary" @click.native="doSave">Save</v-btn>
        <v-btn color="red darken-1" text @click.native="doCancel">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
// OK-480: Added 15-Dec
import * as TableConst from '@/mixins/table'
import { expandURI, filterQuery } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { formatDisplayDate } from '@/utils/date'

export default {
  data() {
    return {
      loading: false,
      submitting: false,
      clmDocSection: false,
      reviewMode: false,
      queryMode: false,
      disabledSentDate: false,
      disabledRecvDate: false,
      totalItems: 0,
      findDocHdgList: [],
      findClmDocList: [],
      items: [],
      interlist: [],
      menu: {},
      supportedFormat: [],
      dtoList: [],
      pagination: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      headers: [
        { text: 'Claim Document', align: 'left', value: 'docHdgDesc' },
        { text: 'Claimant / Item', align: 'left', value: 'clmtNo' },
        // { text: 'Claim Item', align: 'left', value: 'clmItem' },
        { text: 'Service Provider', align: 'left', value: 'inter' },
        { text: 'Tran Type 1', align: 'left', value: 'tranType1' },
        { text: 'Doc No.', align: 'left', value: 'docNo' },
        { text: 'Gen Date', align: 'left', value: 'genDate' },
        { text: 'Sent Date.', align: 'left', value: 'sentDate' },
        { text: 'Recd Date', align: 'left', value: 'recvDate' },
        TableConst.tableActionHeader
      ],
      labels: {
        polType: 'Policy Type',
        prtAckLtr: 'Print',
        documentNo: 'docNo input',
        docHdg: 'Claim Doc',
        clmtNo: 'Claimant No. / Claim Item',
        clmItem: 'Claim Item',
        inter: 'Service Provider',
        tranType1: 'Tran Type 1 / Doc No.',
        docNo: 'Doc No.',
        genDate: 'Generated Date',
        genBy: 'Generated By',
        sentDate: 'Sent Date',
        sentBy: 'Sent By',
        recvDate: 'Received Date',
        recvBy: 'Received By',
        genDoc: 'Generate Document',
        emailRecip: 'Email Recipient',
        smsRecip: 'SMS Recipient',
        emailAgt: 'Email Agent',
        smsAgt: 'SMS Agent',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      clmDocForm: {
        documentNo: '',
        docHdg: undefined,
        docHdgDesc: undefined,
        clmtNo: undefined,
        clmItem: undefined,
        clmtNoClmItem: undefined,
        inter: undefined,
        tranType1: undefined,
        docNo: undefined,
        tranType1DocNo: undefined,
        genDate: undefined,
        genBy: undefined,
        sentDate: undefined,
        sentBy: undefined,
        recvDate: undefined,
        genDoc: false,
        emailRecip: false,
        smsRecip: false,
        emailAgt: false,
        smsAgt: false,
        createdBy: undefined,
        createdDate: undefined,
        modifiedBy: undefined,
        modifiedDate: undefined,
        tranId: undefined,
        clmNo: undefined,
        clmResCat: undefined,
        branch: undefined,
        recvBy: undefined,
        delDoc: undefined
      },
      form: {
        docHdg: undefined,
        clmNo: undefined,
        docNo: '',
        clmtNo: 0,
        clmItem: 0,
        serProvider: '',
        clmResCat: '',
        branch: '',
        tranType1: '',
        fund: ''
      },
      clmMasterList: [],
      docNoInput: [{ docNo: '620' }, { docNo: '622' }],
      clmDocNoList: [
        { code: '620', value: 'Claims Acknowledgement Letter', codeValue: '620 - Claims Acknowledgement Letter' },
        { code: '622', value: 'Documentation Request Letter', codeValue: '622 - Documentation Request Letter' },
        { code: '623', value: 'Service Provider Appointment Letter', codeValue: '623 - Service Provider Appointment Letter' },
        { code: '624', value: 'Offer Settlement Letter', codeValue: '624 - Offer Settlement Letter' },
        { code: '625', value: 'Discharge Voucher', codeValue: '625 - Discharge Voucher' },
        { code: '626', value: 'Subrogation Form', codeValue: '626 - Subrogation Form' },
        { code: '627', value: 'Counter Guarantee Letter', codeValue: '627 - Counter Guarantee Letter' },
        { code: '628', value: 'Third Party Claimant PDPA', codeValue: '628 - Third Party Claimant PDPA' }
      ],
      promptRemove: false,
      getEmail: '',
      getMobile: '',
      getAgentEmail: '',
      getAgentSms: '',
      selected: {
        tranId: null,
        docHdg: null,
        docHdgDesc: null,
        clmNo: null,
        clmtNo: null,
        clmItem: null,
        inter: null,
        tranType1: null,
        docNo: null
      }
    }
  },
  mounted() {
    this.doInit()
  },
  computed: {
    commonInfo() {
      return this.$store.state.claims.claimDetail.commonInfo
    },
    getMenu() {
      return this.$store.state.claims.claimDetail.menu
    }
  },
  methods: {
    async doInit() {
      await this.$store.dispatch('claimReportsInit')
      this.getRptMenu()
      this.fetchInterList()
      this.fetchData()
    },
    async getRptMenu() {
      try {
        const apiURI2 = this.getMenu.initClmAckn
        const result2 = await this.$http.get(apiURI2)
        if (result2.data) {
          const { data } = result2.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result2.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    setDocNoInput() {
      for (var i = 0; i < this.docNoInput.length; i++) {
        this.clmDocForm.documentNo += this.docNoInput[i].docNo + ','
      }
      this.clmDocForm.documentNo = this.clmDocForm.documentNo.slice(0, -1)
    },
    // async findDocHdg(dt) {
    //   const apiURI = this.getMenu.findDocumentHeading
    //   if (apiURI) {
    //     try {
    //       for (var i = 0; i < dt.length; i++) {
    //         const expand = {
    //           docNo: dt[i].docNo,
    //           polType: this.commonInfo.polType
    //         }
    //         const result = await this.$http.get(expandURI(apiURI, expand))
    //         const { data } = result.data
    //         if (data) {
    //           const convertList = {
    //             docNo: data.docNo,
    //             polType: data.polType,
    //             result: data.getResult
    //           }
    //           this.findDocHdgList.push(convertList)
    //         }
    //       }
    //     } catch (err) {
    //       const { data } = err.response
    //       if (data) {
    //         this.message(data)
    //         this.fieldMessage(data)
    //       }
    //       return false
    //     }
    //     return true
    //   }
    // },
    // async findClaimDocument(dat) {
    //   const apiURI = this.getMenu.findClaimDocuments
    //   if (apiURI) {
    //     try {
    //       for (var j = 0; j < dat.length; j++) {
    //         if (dat[j].result === true) {
    //           const expand = {
    //             docHdg: dat[j].docNo,
    //             clmNo: this.commonInfo.clmNo,
    //             polType: dat[j].polType,
    //             clmtNo: this.form.clmtNo,
    //             clmItem: this.form.clmItem,
    //             serProvider: this.form.serProvider,
    //             clmResCat: this.form.clmResCat,
    //             branch: this.form.branch,
    //             tranType1: this.form.tranType1,
    //             docNo: this.form.docNo,
    //             fund: this.form.fund
    //           }
    //           const result = await this.$http.get(expandURI(apiURI, expand))
    //           const { data } = result.data
    //           if (data) {
    //             const dataList = {
    //               docHdg: data.docHdg,
    //               clmNo: data.clmNo,
    //               result: data.result,
    //               clmtNo: this.form.clmtNo,
    //               clmItem: this.form.clmItem,
    //               serProvider: this.form.serProvider,
    //               clmResCat: this.form.clmResCat,
    //               branch: this.form.branch,
    //               tranType1: this.form.tranType1,
    //               docNo: this.form.docNo,
    //               fund: this.form.fund
    //             }
    //             this.findClmDocList.push(dataList)
    //           }
    //         }
    //       }
    //     } catch (err) {
    //       const { data } = err.response
    //       if (data) {
    //         this.message(data)
    //         this.fieldMessage(data)
    //       }
    //       return false
    //     }
    //     return true
    //   }
    // },
    async getEmailSmsAgtByAgent() {
      const apiURI = this.getMenu.getEmailSmsAgtByAgent
      if (apiURI) {
        try {
          const expand = {
            agent: this.commonInfo.agent
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.getAgentEmail = data.agentEmail
            this.getAgentSms = data.agentSms
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async getEmailMobileByPolNo() {
      const apiURI = this.getMenu.getEmailMobileByPolNo
      if (apiURI) {
        try {
          const expand = {
            polNo: this.commonInfo.polNo,
            renCnt: this.commonInfo.renCnt,
            endtCnt: this.commonInfo.endtCnt
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.getEmail = data.email
            this.getMobile = data.mobile
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    // async doCreate(dta) {
    //   const apiURI = this.getMenu.createClmDoc
    //   if (apiURI) {
    //     try {
    //       for (var k = 0; k < dta.length; k++) {
    //         if (dta[k].result === false) {
    //           const expand = {
    //             docHdg: dta[k].docHdg,
    //             clmNo: this.commonInfo.clmNo,
    //             clmtNo: this.form.clmtNo,
    //             clmItem: this.form.clmItem,
    //             inter: this.form.serProvider,
    //             clmResCat: this.form.clmResCat,
    //             branch: this.form.branch,
    //             tranType1: this.form.tranType1,
    //             docNo: this.form.docNo,
    //             fund: this.form.fund
    //           }
    //           const result = await this.$http.post(apiURI, expand)
    //           const { data } = result
    //           if (data) {
    //             this.notify(data)
    //             this.message(data)
    //             this.fieldMessage(data)
    //           }
    //         }
    //       }
    //     } catch (err) {
    //       const { data } = err.response
    //       if (data) {
    //         this.message(data)
    //         this.fieldMessage(data)
    //       }
    //       return false
    //     }
    //     return true
    //   }
    // },
    async fetchData(options) {
      this.loading = true
      const { page, itemsPerPage } = this.pagination
      let expand = {
        page: page - 1,
        size: itemsPerPage,
        clmNo: this.commonInfo.clmNo,
        options: options
      }
      const apiUrl = this.getMenu.getClmDoctList
      if (apiUrl) {
        try {
          this.loading = true
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), this.filter, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  tranId: datamap.tranId,
                  docHdg: datamap.docHdg,
                  docHdgDesc: this.filterDocHdgNo(datamap.docHdg),
                  clmNo: datamap.clmNo,
                  clmtNo: datamap.clmtNo,
                  clmItem: datamap.clmItem,
                  inter: datamap.inter === undefined ? '' : datamap.inter,
                  clmResCat: datamap.clmResCat === undefined ? '' : datamap.clmResCat,
                  branch: datamap.branch === undefined ? '' : datamap.branch,
                  tranType1: datamap.tranType1 === undefined ? '' : datamap.tranType1,
                  docNo: datamap.docNo === undefined ? '' : datamap.docNo,
                  genDoc: datamap.genDoc,
                  emailRecip: datamap.emailRecip,
                  smsRecip: datamap.smsRecip,
                  emailAgt: datamap.emailAgt,
                  smsAgt: datamap.smsAgt,
                  genDate: datamap.genDate,
                  genBy: datamap.genBy === '0' ? '' : datamap.genBy,
                  sentDate: datamap.sentDate,
                  sentBy: datamap.sentBy === '0' ? '' : datamap.sentBy,
                  recvDate: datamap.recvDate,
                  recvBy: datamap.recvBy === '0' ? '' : datamap.recvBy,
                  delDoc: datamap.delDoc,
                  createdBy: datamap.createdBy,
                  createdDate: datamap.createdDate,
                  modifiedBy: datamap.modifiedBy,
                  modifiedDate: datamap.modifiedDate
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    async fetchInterList() {
      const apiUrl = this.getMenu.getInterName1List
      if (apiUrl) {
        try {
          this.interlist = []
          const result = await this.$http.get(apiUrl)
          if (result.data.dataList) {
            this.$set(this, 'interlist', result.data.dataList)
          }
        } catch (err) {
          this.interlist = []
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doQuery(data) {
      this.queryMode = true
      this.disabledSentDate = true
      this.disabledRecvDate = true
      this.reviewMode = false
      this.clmDocSection = true
      this.clmDocForm.docHdg = data.item.docHdg
      this.clmDocForm.docHdgDesc = data.item.docHdgDesc
      this.clmDocForm.clmtNo = data.item.clmtNo
      this.clmDocForm.clmItem = data.item.clmItem
      this.clmDocForm.clmtNoClmItem = data.item.clmtNo + ' / ' + data.item.clmItem
      this.clmDocForm.inter = this.filterInterName1(data.item.inter)
      this.clmDocForm.tranType1 = data.item.tranType1
      this.clmDocForm.docNo = data.item.docNo
      this.clmDocForm.genDate = data.item.genDate
      this.clmDocForm.genBy = data.item.genBy
      this.clmDocForm.sentDate = data.item.sentDate
      this.clmDocForm.sentBy = data.item.sentBy
      this.clmDocForm.recvDate = data.item.recvDate
      this.clmDocForm.recvBy = data.item.recvBy
      this.clmDocForm.genDoc = data.item.genDoc
      this.clmDocForm.emailRecip = data.item.emailRecip
      this.clmDocForm.smsRecip = data.item.smsRecip
      this.clmDocForm.emailAgt = data.item.emailAgt
      this.clmDocForm.smsAgt = data.item.smsAgt
      this.clmDocForm.createdBy = data.item.createdBy
      this.clmDocForm.createdDate = data.item.createdDate
      this.clmDocForm.modifiedBy = data.item.modifiedBy
      this.clmDocForm.modifiedDate = data.item.modifiedDate
      this.$nextTick(() => {
        this.$vuetify.goTo('#clmDocCard')
      })
    },
    canReview(data) {
      return data.sentDate === undefined || data.recvDate === undefined
    },
    doReview(data) {
      this.queryMode = false
      this.reviewMode = true
      this.clmDocSection = true
      this.clmDocForm.tranId = data.item.tranId
      this.clmDocForm.docHdg = data.item.docHdg
      this.clmDocForm.docHdgDesc = data.item.docHdgDesc
      this.clmDocForm.clmNo = data.item.clmNo
      this.clmDocForm.clmtNo = data.item.clmtNo
      this.clmDocForm.clmItem = data.item.clmItem
      this.clmDocForm.clmtNoClmItem = data.item.clmtNo + ' / ' + data.item.clmItem
      this.clmDocForm.inter = this.filterInterName1(data.item.inter)
      this.clmDocForm.clmResCat = data.item.clmResCat
      this.clmDocForm.tranType1 = data.item.tranType1
      this.clmDocForm.docNo = data.item.docNo
      if (data.item.tranType1 === '' || data.item.docNo === '') {
        this.clmDocForm.tranType1DocNo = ''
      } else {
        this.clmDocForm.tranType1DocNo = data.item.tranType1 + ' / ' + data.item.docNo
      }
      this.clmDocForm.branch = data.item.branch
      this.clmDocForm.genDate = data.item.genDate
      this.clmDocForm.genBy = data.item.genBy
      if (data.item.genDate !== undefined && data.item.emailRecip === false && data.item.smsRecip === false) {
        this.disabledSentDate = false
        this.clmDocForm.sentBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      } else {
        this.disabledSentDate = true
        this.clmDocForm.sentBy = data.item.sentBy
      }
      this.clmDocForm.sentDate = data.item.sentDate
      if (data.item.recvDate === undefined) {
        this.disabledRecvDate = false
        this.clmDocForm.recvBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      } else {
        this.disabledRecvDate = true
        this.clmDocForm.recvBy = data.item.recvBy
      }
      this.clmDocForm.recvDate = data.item.recvDate
      this.clmDocForm.genDoc = data.item.genDoc
      this.clmDocForm.emailRecip = data.item.emailRecip
      this.clmDocForm.smsRecip = data.item.smsRecip
      this.clmDocForm.emailAgt = data.item.emailAgt
      this.clmDocForm.smsAgt = data.item.smsAgt
      this.clmDocForm.delDoc = data.item.delDoc
      this.clmDocForm.createdBy = data.item.createdBy
      this.clmDocForm.createdDate = data.item.createdDate
      this.clmDocForm.modifiedBy = data.item.modifiedBy
      this.clmDocForm.modifiedDate = data.item.modifiedDate
      this.$nextTick(() => {
        this.$vuetify.goTo('#clmDocCard')
      })
    },
    canRemove(data) {
      return data.genDate === undefined
    },
    doPromptRemove(data) {
      this.selected = data.item
      this.promptRemove = true
    },
    async doDelete() {
      this.resetMessages()
      if (this.selected && this.selected.docHdg) {
        const apiURI = this.getMenu.deleteClmDoc
        if (apiURI) {
          const expand = {
            tranId: this.selected.tranId,
            docHdg: this.selected.docHdg,
            clmNo: this.selected.clmNo,
            clmtNo: this.selected.clmtNo,
            clmItem: this.selected.clmItem,
            inter: this.selected.inter,
            tranType1: this.selected.tranType1,
            docNo: this.selected.docNo
          }
          this.$http
            .post(apiURI, expand)
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.promptRemove = false
              this.fetchData()
            })
            .catch((err) => {
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        } else {
          this.$toast.error('The request failed because it is trying to execute an invalid API url.')
        }
      }
    },
    async doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.doUpdate().then((success) => {
            if (success) {
              this.fetchData()
            }
          })
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doUpdate() {
      const apiUrl = this.getMenu.updateClmDoc
      if (apiUrl) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiUrl, this.clmDocForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.clmDocSection = false
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.$toast.error('Fail to Save Record')
            this.message(data)
            this.fieldMessage(data)
            return false
          }
        }
        return true
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
        return false
      }
    },
    doReprint() {
      this.setDto().then((success1) => {
        if (success1 === true) {
          this.generateClmDoc(this.dtoList)
        }
      })
    },
    async setDto() {
      let agtEmail
      let agtSMS
      this.dtoList = []
      for (var m = 0; m < this.items.length; m++) {
        // find top 1 of intermediaryMaster
        if (this.items[m].emailAgt === true && this.items[m].smsAgt === true) {
          agtEmail = this.getAgentEmail
          agtSMS = this.getAgentSms
        }
        // find all clmDoc
        if (this.items[m].genDoc === true && this.items[m].genDate === undefined && this.items[m].delDoc === false) {
          if (this.items[m].docHdg === '620' || this.items[m].docHdg === '622') {
            const dto = {
              clmNo: this.items[m].clmNo,
              sendEmail: true,
              agtEmail: agtEmail,
              agtSMS: agtSMS,
              clmtNo: this.items[m].clmtNo,
              clmItem: this.items[m].clmItem,
              inter: this.items[m].inter,
              tranType1: this.items[m].tranType1,
              docNo: this.items[m].docNo,
              clmResCat: this.items[m].clmResCat,
              docHdg: this.items[m].docHdg,
              emailRecip: this.items[m].emailRecip,
              smsRecip: this.items[m].smsRecip,
              emailAgt: this.items[m].emailAgt,
              smsAgt: this.items[m].smsAgt,
              recipName1: this.commonInfo.insdName1,
              recipName2: this.commonInfo.insdName2,
              recipName3: this.commonInfo.insdName3,
              recipName4: this.commonInfo.insdName4,
              recipAdd1: this.commonInfo.insdAddr1,
              recipAdd2: this.commonInfo.insdAddr2,
              recipAdd3: this.commonInfo.insdAddr3,
              recipAdd4: this.commonInfo.insdAddr4,
              recipPostCode: this.commonInfo.postCode,
              recipEmail: this.commonInfo.email,
              recipSms: this.getMobile,
              polType: this.commonInfo.polType
            }
            this.dtoList.push(dto)
          }
        }
      }
      return true
    },
    async generateClmDoc(vale) {
      for (var d = 0; d < vale.length; d++) {
        const apiURI = this.getMenu.exportClaimAckn
        if (apiURI) {
          try {
            this.submitting = true
            await this.$http.post(apiURI, vale[d])
            this.submitting = false
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
            this.submitting = false
          }
        } else {
          this.errorMessage('The request failed because it is trying to execute an invalid API url.')
        }
      }
    },
    doCancel() {
      this.clmDocSection = false
    },
    doClose() {
      this.$emit('close')
    },
    filterDocHdgNo(dt) {
      for (var q = 0; q < this.clmDocNoList.length; q++) {
        if (this.clmDocNoList[q].code === dt) {
          return this.clmDocNoList[q].codeValue
        }
      }
    },
    filterInterName1(val) {
      for (let inter of this.interlist) {
        if (inter.value === val) {
          return inter.label
        }
      }
      return ''
    },
    formatDisplayDate(date) {
      if (date !== undefined) {
        return formatDisplayDate(date)
      }
    }
  },
  watch: {
    'pagination': function (value) {
      this.fetchData(false)
    },
    refresh: function (value) {
      if (value) {
        this.doInit()
      }
    }
  },
  mixins: [TableConst.default, MessageMixin, commonAjaxMixin],
  props: {
    refresh: {
      type: Boolean,
      default: true
    }
  }
}
</script>
